import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=33bb6438&scoped=true"
import script from "./Leader.vue?vue&type=script&lang=js"
export * from "./Leader.vue?vue&type=script&lang=js"
import style0 from "./Leader.vue?vue&type=style&index=0&id=33bb6438&prod&scoped=true&lang=css"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=33bb6438&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb6438",
  null
  
)

export default component.exports